import { Controller } from "@hotwired/stimulus"

// แถวการ์ดเลื่อนแนวนอน (รีวิว/teaser) — ปัดได้เอง + ปุ่มลูกศรเลื่อนทีละการ์ด
// ปุ่มซ่อน/จางอัตโนมัติเมื่อสุดขอบ
export default class extends Controller {
  static targets = ["row", "prev", "next"]

  connect() {
    this.update = this.update.bind(this)
    this.rowTarget.addEventListener("scroll", this.update, { passive: true })
    window.addEventListener("resize", this.update)
    this.update()
  }

  disconnect() {
    this.rowTarget.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  prev() {
    this.rowTarget.scrollBy({ left: -this.step(), behavior: "smooth" })
  }

  next() {
    this.rowTarget.scrollBy({ left: this.step(), behavior: "smooth" })
  }

  // ระยะเลื่อน = ความกว้างการ์ดแรก + ช่องว่าง (fallback ครึ่งจอ)
  step() {
    const card = this.rowTarget.firstElementChild
    return card ? card.offsetWidth + 16 : this.rowTarget.clientWidth / 2
  }

  update() {
    const row = this.rowTarget
    const atStart = row.scrollLeft <= 4
    const atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4

    if (this.hasPrevTarget) this.prevTarget.classList.toggle("opacity-25", atStart)
    if (this.hasNextTarget) this.nextTarget.classList.toggle("opacity-25", atEnd)
  }
}
